<!-- Copyright (c) 2022 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="Haulage-Trip-Report-Main">
    <div class="left-container" :class="[closeLeftTab ? 'left-tab-close' : '']">
      <div class="arrow-button">
        <img
          :style="{
            transform: `${
              closeLeftTab && !narrowWindow ? `scaleX(-1)`
              : !closeLeftTab && !narrowWindow ? `scaleX(1)`
              : closeLeftTab && narrowWindow ? `rotate(90deg) scaleX(-1)`
              : `rotate(90deg) scaleX(1)`
            }`,
          }"
          @click="closeLeftTab = !closeLeftTab"
          src="https://img.icons8.com/material-rounded/96/000000/double-left.png"
        />
      </div>
      <div class="refresh-icon" v-if="closeLeftTab">
        <Tooltip
          style="cursor: pointer"
          icon="https://dsmapi.logistics.systems/dsm6gicons/icons8-refresh-64.png"
          :position="narrowWindow ? 'left' : 'bottom'"
          :iconSize="30"
          :yOffset="narrowWindow ? 0 : 30"
          :xOffset="narrowWindow ? -10 : 0"
          @click.native="refreshClicked"
        >
          <div slot="tooltipText">
            <div
              >Report Name:
              <span :style="{ color: selectedReportName ? '' : 'red' }">{{
                selectedReportName ? selectedReportName['Report'] : 'Not Selected'
              }}</span></div
            >
            <div
              >Date Field:
              <span :style="{ color: selectedDateField ? '' : 'red' }">{{
                selectedDateField ? selectedDateField['Date Field'] : 'Not Selected'
              }}</span></div
            >
            <div
              >From:
              <span :style="{ color: selectedFromDate ? '' : 'red' }">{{
                selectedFromDate ? $dateTime.getDateTime(new Date(selectedFromDate), 'yyyy-MM-dd') : 'Not Selected'
              }}</span></div
            >
            <div
              >To:
              <span :style="{ color: selectedToDate ? '' : 'red' }">{{
                selectedToDate ? $dateTime.getDateTime(new Date(selectedToDate), 'yyyy-MM-dd') : 'Not Selected'
              }}</span></div
            >
          </div>
        </Tooltip>
        <!-- <img @click="refreshClicked" title="Click to Refresh" src="https://dsmapi.logistics.systems/dsm6gicons/icons8-refresh-64.png" alt=""> -->
      </div>
      <div class="left-container-content" :style="{ display: closeLeftTab ? 'none' : '' }">
        <button @click="refreshClicked">Refresh</button>

        <Dropdown
          class="dropdown"
          :items="itemReportName"
          itemKey="Report"
          :selectedObject.sync="selectedReportName"
          textAlign="left"
          placeholder="Report Name"
          :isRequired="true"
          :errorMessage.sync="errorReportName"
          @selected="reportNameDropdownSelected"
        />

        <Dropdown
          class="dropdown"
          :items="itemDateFieldFiltered"
          itemKey="Date Field"
          placeholder="Date Field"
          textAlign="left"
          :isRequired="true"
          :selectedObject.sync="selectedDateField"
          :errorMessage.sync="errorDateField"
        />

        <DateTimePicker
          placeholder="From"
          :value.sync="selectedFromDate"
          :showTime="false"
          :isDisable="false"
          :isRequired="true"
          :errorMessage.sync="fromDateError"
        />

        <DateTimePicker
          placeholder="To"
          :value.sync="selectedToDate"
          :showTime="false"
          :isDisabled="false"
          :isRequired="true"
          :errorMessage.sync="toDateError"
        />
      </div>
    </div>
    <div class="right-container">
      <div class="generated-report-details">
        <div class="left-side">
          <div class="filtered-content">
            <div class="filtered-title"> Report Name </div>
            <div class="filtered-colon"> : </div>
            <div class="filtered-result">
              {{ injectedReportName }}
            </div>
          </div>

          <div class="filtered-content">
            <div class="filtered-title"> Date Field </div>
            <div class="filtered-colon"> : </div>
            <div class="filtered-result">
              {{ injectedDateField }}
            </div>
          </div>

          <div class="filtered-content">
            <div class="filtered-title"> From {{ injectedDateField }} </div>
            <div class="filtered-colon"> : </div>
            <div class="filtered-result">
              {{ injectedFromDate }}
            </div>
          </div>

          <div class="filtered-content">
            <div class="filtered-title"> To {{ injectedDateField }} </div>
            <div class="filtered-colon"> : </div>
            <div class="filtered-result">
              {{ injectedToDate }}
            </div>
          </div>
        </div>
        <div class="right-side"> Last Refreshed : {{ lastRefreshed }} </div>
      </div>
      <div :style="{ height: reportContainerHeight }" class="report-container">
        <TableBox
          :title="injectedReportName"
          :tableData="tableBoxData"
          :loading="tableLoading"
          :additionalButtons="tableBoxAdditionalButtons"
          :hideColumns="columnsHide"
          :maxSelection="0"
          :columnOrderViews.sync="tableBoxColumnOrderViews"
          :columnOrderID="tableBoxColumnOrderID"
          @buttonClicked="tableBoxButtonClicked"
        />
      </div>
      <div v-if="showCustomMap" :style="{ height: customMapContainerHeight }" class="custom-map-container">
        <div class="close-button-container">
          <img
            class="close-button"
            src="https://dsmlib.logistics.systems/Icons/icons8-close-90.png"
            alt="Close"
            @click="customMapCloseButtonClicked"
          />
        </div>
        <CustomMap
          class="custom-map-component"
          :viewMode="true"
          :hideSlot="true"
          ref="customMapComponent"
          :maxMarkerCount="20"
          :markers.sync="destinationMarkers"
        />
      </div>
    </div>
    <!--Attachment Window-->
    <div class="attchWin-main" v-if="showAttachmentWindow">
      <button class="attchWin-close" @click="closeAttachmentWindow">X</button>
      <div class="attchWin-display" v-if="imageExist">
        <div class="image-container">
          <div v-if="attachmentList.length > 1" class="leftButton">
            <button class="navButton-left" @click="navAtt('prev')">&lt;</button>
          </div>

          <!-- image container and buttons -->
          <div class="attchWin-attachment">
            <img style="object-fit: contain" :src="image" />
          </div>

          <div v-if="attachmentList.length > 1" class="rightButton">
            <button class="navButton-right" @click="navAtt('next')">></button>
          </div>
        </div>

        <div class="attchWin-details">
          <div class="count">
            <b>{{ currentAttachmentIndex + 1 }}</b> / {{ attachmentList.length }} Images
          </div>
          <div v-if="injectedReportName == 'Employee Clock In/Out (Mobile)'" class="attchWin-info">
            <!--these details are only applicable for the clock in/out report -->
            <table id="tableContent">
              <tr>
                <th>Vehicle</th>
                <td>{{ selectedData['Vehicle #'] }} ({{ selectedData['Vehicle Code'] }})</td>
              </tr>

              <tr>
                <th>Odometer</th>
                <td>{{ selectedData['Odometer'] }}</td>
              </tr>

              <tr>
                <th>Balance Litre</th>
                <td>{{ selectedData['Balance Litre'] }}</td>
              </tr>

              <tr>
                <th>Employee</th>
                <td>{{ selectedData['Employee Name'] }}({{ selectedData['Employee Code'] }})</td>
              </tr>

              <tr>
                <th>{{ selectedData['In/Out'] == 'Out' ? 'Clock Out Time' : 'Clock In Time' }}</th>
                <td>{{ selectedData['Clock In/Out Time'] }}</td>
              </tr>

              <tr>
                <th>Remarks</th>
                <td>{{ selectedData['Remarks'] }}</td>
              </tr>

              <tr>
                <th>PM Check</th>
                <td>{{ selectedData['PM Check'] + '\n' + selectedData['PM Check Remarks'] }}</td>
              </tr>

              <tr>
                <th>Tyre Check</th>
                <td>{{ selectedData['Tyre Check'] + '\n' + selectedData['Tyre Check Remarks'] }}</td>
              </tr>

              <tr>
                <th>Engine Check</th>
                <td>{{ selectedData['Engine Check'] + '\n' + selectedData['Engine Check Remarks'] }}</td>
              </tr>

              <tr>
                <th>SL Check</th>
                <td>{{ selectedData['SL Check'] + '\n' + selectedData['SL Check Remarks'] }}</td>
              </tr>

              <tr>
                <th>Tyre Pressure</th>
                <td>{{ selectedData['Tyre Pressure'] + '\n' + selectedData['Tyre Pressure Remarks'] }}</td>
              </tr>

              <tr>
                <th>Light & Signal</th>
                <td>{{ selectedData['Lights & Signal'] + '\n' + selectedData['Lights & Signal Remarks'] }}</td>
              </tr>

              <tr>
                <th>Brakes</th>
                <td>{{ selectedData['Brakes'] + '\n' + selectedData['Brakes Remarks'] }}</td>
              </tr>

              <tr>
                <th>1 Torch Light</th>
                <td>{{ selectedData['1 Torch Light'] }}</td>
              </tr>

              <tr>
                <th>1 Warning Triangle</th>
                <td>{{ selectedData['1 Warning Triangle'] }}</td>
              </tr>

              <tr>
                <th>1 First Aid Kit</th>
                <td>{{ selectedData['1 First Aid Kit'] }}</td>
              </tr>

              <tr>
                <th>5 Safety Cones</th>
                <td>{{ selectedData['5 Safety Cones'] }}</td>
              </tr>

              <tr>
                <th>Reflecive Delineators</th>
                <td>{{ selectedData['Reflecive Delineators'] }}</td>
              </tr>

              <tr>
                <th>1 Fire Extinguisher</th>
                <td>{{ selectedData['1 Fire Extinguisher'] }}</td>
              </tr>

              <tr>
                <th>1 Safety Jacket</th>
                <td>{{ selectedData['1 Safety Jacket'] }}</td>
              </tr>

              <tr>
                <th style="word-break: break-all">Fever/Flu/Diarrhea/Dizzy</th>
                <td>{{ selectedData['Fever/Flu/Diarrhea/Dizzy'] + '\n' + selectedData['Sickness Remarks'] }}</td>
              </tr>

              <tr>
                <th>Body Temp</th>
                <td>{{ selectedData['Body Temp'] + '\n' + selectedData['Body Temp Remarks'] }}</td>
              </tr>

              <tr>
                <th>Blood Pressure</th>
                <td>{{ selectedData['Blood Pressure'] + '\n' + selectedData['Blood Pressure Remarks'] }}</td>
              </tr>

              <tr>
                <th>Taken Medicine</th>
                <td>{{ selectedData['Medicine Taken?'] + '\n' + selectedData['Medicine Remarks'] }}</td>
              </tr>
            </table>
          </div>
          <div v-else-if="injectedReportName == 'Driver Update Log (Mobile)'" class="attchWin-info">
            <!--these details are only applicable for driver update log -->
            <table v-if="selectedData['Record Type'] == 'TAS'" id="tableContent">
              <!-- details for TAS records -->
              <tr>
                <th>User ID</th>
                <td>{{ selectedData['User ID'] }}</td>
              </tr>

              <tr>
                <th>Log Date</th>
                <td>{{ selectedData['Log Date'] }}</td>
              </tr>

              <tr>
                <th>Date Updated</th>
                <td>{{ selectedData['Date Updated'] }}</td>
              </tr>

              <tr>
                <th>Consignment No</th>
                <td>{{ selectedData['Consignment No'] }}</td>
              </tr>

              <tr>
                <th>Container No</th>
                <td>{{ selectedData['Container No'] }}</td>
              </tr>

              <tr>
                <th>Remarks</th>
                <td>{{ selectedData['Remarks'] }}</td>
              </tr>
            </table>

            <table v-else-if="selectedData['Record Type'].startsWith('CLOCK')" id="tableContent">
              <!-- details for clock in/out/fail records -->
              <tr>
                <th>User ID</th>
                <td>{{ selectedData['User ID'] }}</td>
              </tr>

              <tr>
                <th>Log Date</th>
                <td>{{ selectedData['Log Date'] }}</td>
              </tr>

              <tr>
                <th>PM Reg No</th>
                <td>{{ selectedData['PM Reg No'] }}</td>
              </tr>

              <tr>
                <th>Odometer</th>
                <td>{{ selectedData['Odometer'] }}</td>
              </tr>

              <tr>
                <th>Remarks</th>
                <td>{{ selectedData['Remarks'] }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div v-else class="attchWin-display">
        <div style="margin: 0 auto">No Attachments Found</div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {},
  computed: {
    reportContainerHeight: function () {
      return this.showCustomMap ? 'calc(50% - 41px)' : 'calc(100% - 83px)';
    },
    customMapContainerHeight: function () {
      return this.showCustomMap ? 'calc(50% - 41px)' : 0;
    },
    itemDateFieldFiltered: function () {
      if (!this.selectedReportName || Object.keys(this.selectedReportName).length === 0) {
        return [];
      }

      return this.itemDateField.filter((dateField) => {
        return dateField['Report Key'] === this.selectedReportName['Report Key'];
      });
    },
  },
  watch: {},
  data: function () {
    return {
      // set true to close left tab
      closeLeftTab: false,
      // last refresh time on top right
      lastRefreshed: null,
      // data for dropdown
      itemReportName: [],
      selectedReportName: null,
      injectedReportName: 'Report',
      errorReportName: '',
      itemDateField: [],
      selectedDateField: null,
      injectedDateField: '',
      errorDateField: '',
      // data for datetimepicker components
      selectedFromDate: null,
      injectedFromDate: '',
      fromDateError: '',
      selectedToDate: null,
      injectedToDate: '',
      toDateError: '',

      tableBoxData : [],
      tableLoading : false,
      columnsHide : [],
      columnsNumber : {},
      tableBoxAdditionalButtons: [],
      tableBoxColumnOrderViews: [],
      tableBoxColumnOrderID: null,

      showCustomMap: false,

      narrowWindow: false,
      showAttachmentWindow: false,
      attachmentList: [],
      imageExist: false,
      image: '',
      currentAttachmentIndex: 0,
      selectedData: [],

      //geofences part
      destinationMarkers: [],
      geofenceListData: [],
    };
  },
  props: {},
  methods: {
    formatCurrency: function (format, value) {
      let [group, sym, numOfDigits] = format.split('');
      try {
        if (typeof value == 'string') {
          value = parseFloat(value);
        }
        let temp = value.toFixed(numOfDigits);
        let [front, back] = temp.split('.');
        let result = `${Number(front).toLocaleString()}${sym}${back}`;
        result = result.replace(',', group);
        return result;
      } catch (e) {
        console.error(e);
      }
    },
    reportNameDropdownSelected: function (newReportNameSelectedObject) {
      this.selectedDateField = null; // everytime the report name dropdown is deselected or a new report name is selected, clear the date field dropdown
    },
    errorReportNameCheck: function () {
      if (!this.selectedReportName) {
        this.errorReportName = 'Please choose one input Report Name';
        return true;
      }
      return false;
    },
    errorDateFieldCheck: function () {
      if (!this.selectedDateField) {
        this.errorDateField = 'Please choose one input date';
        return true;
      }
      return false;
    },

    errorDatePickerCheck: function () {
      if (!this.selectedFromDate && !this.selectedToDate) {
        this.fromDateError = 'Please choose a From Date';
        this.toDateError = 'Please choose a To Date';
        return true;
      }

      if (!this.selectedFromDate) {
        this.fromDateError = 'Please choose a From Date';
        return true;
      }

      if (!this.selectedToDate) {
        this.toDateError = 'Please choose a To Date';
        return true;
      }

      if (this.selectedFromDate.getTime() > this.selectedToDate.getTime()) {
        this.fromDateError = 'From Date > To Date';
        this.toDateError = 'From Date > To Date';
        return true;
      }
      return false;
    },

    refreshClicked : async function() {
      // check the filters whether is correctly selected / blank check
      if (this.errorReportNameCheck() || this.errorDateFieldCheck() || this.errorDatePickerCheck()){
        this.$showAlert('error', 'Filters are incomplete');
        return;
      }

      if (this.injectedReportName.includes('Distance')) {
        let selection = await this.$showAlert('warning', 'Including distance in the report might take up some time', 'Proceed to Refresh?', [{color : 'lightgreen', text : 'Ok'}, {color: 'lightgray', text: 'Cancel'}]);
        if (selection === 'Cancel') {
          return;
        }
      }

      this.lastRefreshed = this.$dateTime.getDateTime(new Date(), 'yyyy-MM-dd HH:mm');
      // injected = reactive strings/object
      this.injectedReportName = this.selectedReportName['Report'];
      this.injectedDateField = this.selectedDateField['Date Field'];
      this.injectedFromDate = this.$dateTime.getDateTime(this.selectedFromDate, 'yyyy-MM-dd');
      this.injectedToDate = this.$dateTime.getDateTime(this.selectedToDate, 'yyyy-MM-dd');

      this.tableBoxData = [];
      this.tableBoxColumnOrderViews = [];
      this.tableBoxColumnOrderID = null;
      this.tableLoading = true;
      let apiRet = await this.$apiCallV2(`/HaulageReport/GetHaulageTripReport?startdate=${this.injectedFromDate}&enddate=${this.injectedToDate}&datetype=${this.injectedDateField}&reportname=${this.injectedReportName}`, null, null, {message : `{{errorMessage}}`});
      this.tableLoading = false;

      if (apiRet.length == 0) {
        return;
      }

      apiRet = this.$jsonNullToString(apiRet);
      if (apiRet[0]["Results"] == 1) { // if API returned an error
        this.$showAlert("error", "An error occurred", apiRet[0]["ErrMsg"], [{"text": "OK"}]);
        return;
      }

      let keyNames = [];
      // // find numerical columns to be right aligned
      // for (let [key, val] of Object.entries(apiRet[0])) {
      //   if (typeof val == 'number' || key == 'Send To PostCode' || key == 'Weight(kg)' || key == 'DO Loc Diff (km)' || key == 'Mileage'){
      //     keyNames.push(key);
      //   }
      // }
      // let temp = {};
      // keyNames.forEach(i => {
      //   temp[i] = 'number'
      // });
      // this.columnsNumber = temp;

      // get currency format
      let format = this.$store.state.currencyFormat;

      // get columns related to currency/weight
      let currencyKeys = keyNames.filter(
        (i) => i.includes('Inc') || i.includes('Mvt') || i.includes('Revenue') || i.includes('Weight(kg)'),
      );

      // replace all currency key values into the specified fromat
      let finalData = apiRet.map((obj) => {
        for (let i in obj) {
          if (currencyKeys.includes(i)) {
            let tempValue = this.formatCurrency(format, obj[i]);
            obj[i] = tempValue;
          }
        }
        return obj;
      });

      // set hidden columns and additional buttons
      switch (this.injectedReportName) {
        case 'Haulage Trip Report':
          this.columnsHide = ['JourneyID'];
          this.tableBoxAdditionalButtons = [];
          break;

        case 'Haulage Trip Report with Distance':
          this.columnsHide = ['JourneyID', 'Rows Computed'];
          this.tableBoxAdditionalButtons = [];
          break;

        case 'Employee Clock In/Out (Mobile)':
          this.columnsHide = ['#', 'GUID'];
          this.tableBoxAdditionalButtons = [
            { text: 'View', index: 0, width: 60 },
          ];
          break;

        case 'Driver Update Log (Mobile)':
          this.columnsHide = ['GPSLatitude', 'GPSLongitude', 'Picture Name', 'GUID'];
          this.tableBoxAdditionalButtons = [
            // place buttons as the rightmost column
            { text: 'View on Map', index: Object.keys(finalData[0]).length - this.columnsHide.length, width: 112 },
            {
              text: 'View Pictures',
              index: Object.keys(finalData[0]).length - this.columnsHide.length + 1,
              width: 127,
            },
          ];
          break;

        default:
          this.columnsHide = []; // don't hide any columns for other reports
          this.tableBoxAdditionalButtons = []; // don't show any buttons for other reports
          break;
      }

      const columnOrderID = {
        formname: "Haulage_HaulageReport",
        formctrlname: this.injectedReportName,
      };
      this.tableBoxColumnOrderViews = await this.$apiCallV2('/TableBox/GetColumnOrder', columnOrderID);
      this.tableBoxColumnOrderID = columnOrderID;

      this.tableBoxData = finalData;
    },
    customMapCloseButtonClicked: function () {
      this.showCustomMap = false;
    },
    closeAttachmentWindow: function () {
      this.attachmentList = [];
      this.showAttachmentWindow = false;
    },
    windowResize: function () {
      this.narrowWindow = window.innerWidth < 900;
    },
    tableBoxButtonClicked: async function (btn, data) {
      switch (this.injectedReportName) {
        case 'Employee Clock In/Out (Mobile)': // handle button clicks when Employee Clock In/Out (Mobile) report is being displayed
          switch (btn) {
            case 'View': // handle clicks for the "View" button
              this.selectedData = data;
              this.attachmentList = [];
              this.$fullscreenLoading('Loading Images');

              this.attachmentList = await this.$apiCallV2(
                '/HaulageReport/GetHaulageReportImages',
                {
                  reportname: this.injectedReportName,
                  guid: data['GUID'],
                },
                'post',
                { message: `{{errorMessage}}` },
              );

              this.imageExist = this.attachmentList[0]['picID'] ? true : false;
              if (this.imageExist) {
                this.image = `data:${this.attachmentList[0]['pictype']};base64,${this.attachmentList[0]['picimage']}`;
                this.currentAttachmentIndex = 0;
              }

              this.$fullscreenLoading();
              this.showAttachmentWindow = true;
              break;
          }
          break;

        case 'Driver Update Log (Mobile)':
          switch (btn) {
            case 'View on Map':
              this.showCustomMap = false; // hide customMapComponent
              this.destinationMarkers = []; // clear all markers
              await this.$nextTick(); // wait until UI updates

              if (isNaN(parseFloat(data['GPSLatitude'])) || isNaN(parseFloat(data['GPSLongitude']))) {
                // if either lat or lng can't be parsed as a float, show an error message
                this.$showAlert('error', 'No GPS Coordinates', 'This record has no GPS coordinates', [{ text: 'OK' }]);
                return;
              }

              const geofenceData = this.geofenceListData['AuthorizedGeofences']['GPS_M_POI']; // add geofences first
              for (const gdata of geofenceData) {
                if (gdata['GPSLongitude'] && gdata['GPSLatitude'] && gdata['GPS_M_POIpolygon']) {
                  const geofencePath = gdata['GPS_M_POIpolygon'].map((g) => ({
                    lat: parseFloat(g['Latitude']),
                    lng: parseFloat(g['Longitude']),
                  }));

                  this.destinationMarkers.push({
                    position: {
                      lat: parseFloat(data['GPSLatitude']), // marker position is the same as update location
                      lng: parseFloat(data['GPSLongitude']), // so that all markers will overlap
                    },
                    geofence: geofencePath,
                  });
                }
              }

              this.destinationMarkers.push({
                // add actual marker after geofences
                lat: parseFloat(data['GPSLatitude']),
                lng: parseFloat(data['GPSLongitude']),
              });

              this.showCustomMap = true; // show it customMapComponent

              setTimeout(() => {
                // wait for customMapComponent mounted() to finish executing
                this.$refs['customMapComponent'].centerToMarker({
                  // then center to update locaiton
                  lat: parseFloat(data['GPSLatitude']), // otherwise mounted() may zoom out to fit all geofences in the screen
                  lng: parseFloat(data['GPSLongitude']),
                });
              }, 200);
              //#endregion
              break;

            case 'View Pictures':
              this.selectedData = data;
              this.attachmentList = [];
              this.$fullscreenLoading('Loading Images');

              const requestBody = {
                reportname: this.injectedReportName,
                recordtype: data['Record Type'],
                guid: data['GUID'],
              };

              switch (data['Record Type']) {
                case 'TAS':
                  requestBody['status'] = data['Status'];
                  requestBody['dateupdated'] = data['Date Updated'];
                  break;

                case 'CLOCK IN/OUT FAIL':
                  requestBody['loggeduser'] = data['UserID'];
                  requestBody['logdate'] = data['Log Date'];
              }

              this.attachmentList = await this.$apiCallV2(
                '/HaulageReport/GetHaulageReportImages',
                requestBody,
                'post',
                { message: `{{errorMessage}}` },
              );

              this.imageExist = this.attachmentList[0]['picname'] != null;
              if (this.imageExist) {
                this.image = `data:${this.attachmentList[0]['pictype']};base64,${this.attachmentList[0]['picimage']}`;
                this.currentAttachmentIndex = 0;
              }
              this.showAttachmentWindow = true;

              this.$fullscreenLoading();
              break;
          }
          break;

        default: // should never reach this point
          if (process.env['NODE_ENV'] == 'development') {
            console.error(`Unhandled ${btn} TableBox button click for ${this.injectedReportName} report`);
          }
          break;
      }
    },
    navAtt: function (clicked) {
      switch (clicked) {
        case 'next':
          if (this.currentAttachmentIndex == this.attachmentList.length - 1) {
            this.currentAttachmentIndex = 0;
          } else {
            this.currentAttachmentIndex++;
          }
          break;

        case 'prev':
          if (this.currentAttachmentIndex == 0) {
            this.currentAttachmentIndex = this.attachmentList.length - 1;
          } else {
            this.currentAttachmentIndex--;
          }
          break;

        default: // should never reach here
          if (process.env['NODE_ENV'] == 'development') {
            console.error("navAtt method - clicked not specified. Should be either 'next' or 'prev'");
          }
          break;
      }

      this.image = `data:${this.attachmentList[this.currentAttachmentIndex]['pictype']};base64,${this.attachmentList[this.currentAttachmentIndex]['picimage']}`;
    },
  },
  async mounted() {
    this.narrowWindow = window.innerWidth < 900;

    this.closeLeftTab = false;
    // default refresh datetime on mounted
    this.lastRefreshed = this.$dateTime.getDateTime(new Date(), 'yyyy-MM-dd HH:mm');

    // default from Date and to Date to beginning of the month to end of the month
    var date = new Date();
    this.selectedFromDate = new Date(date.getFullYear(), date.getMonth(), 1);
    this.selectedToDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    this.$fullscreenLoading('Getting Report Type...');
    this.itemReportName = await this.$apiCallV2(`/HaulageReport/GetListMaster?masterfile=RPT_REPORT&module=HMS`);
    this.selectedReportName = this.itemReportName[0];

    this.$fullscreenLoading('Getting Date Field...');
    this.itemDateField = await this.$apiCallV2(
      `/HaulageReport/GetListMaster?masterfile=RPT_REPORT_DATEFIELD&module=HMS`,
    );
    this.selectedDateField = this.itemDateFieldFiltered[0];

    this.$fullscreenLoading('Getting Geofences...');
    this.geofenceListData = await this.$apiCallV2('/HaulageReport/GetAuthorizedGeofences');

  
    this.$fullscreenLoading();

    window.addEventListener('resize', this.windowResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.windowResize);
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.Haulage-Trip-Report-Main {
  font-size: 12px;
  width: 200px;
  height: 100%;
  padding: 10px 45px;
  display: flex;
  overflow: hidden;

  > .left-container {
    border-radius: 5px;
    max-width: 200px;
    width: 100%;
    background-color: white;
    margin-right: 5px;
    height: 100%;
    transition: 0.3s;

    > .arrow-button {
      width: 100%;
      padding: 7px 4px 50px 0px;
      display: flex;
      justify-content: flex-end;

      > img {
        height: 30px;
        width: 30px;
        padding: 2px;
        z-index: 1;
        transform: scale(1);
        transition: 0.3s;
        cursor: pointer;

        // same as > img :hover {}
        &:hover {
          border-radius: 50%;
          background-color: rgba(0, 0, 0, 0.5);
          transition: 0.3s ease;
        }
      }
    }

    > .refresh-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 5px;
      cursor: pointer;
    }

    > .left-container-content {
      background-color: white;
      width: 100%;
      height: 200px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;
      padding-left: 5px;

      > button {
        width: 90%;
        margin-left: 5px;
      }

      > .dropdown {
        width: 95%;
      }
    }
  }

  > .left-tab-close {
    max-width: 40px;
  }

  > .right-container {
    border-radius: 5px;
    width: 100%;
    height: 100%;
    overflow: hidden;

    > .generated-report-details {
      width: 100%;
      border-radius: 5px;
      height: 80px;
      background-color: white;
      margin-bottom: 5px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      > .left-side {
        padding-left: 5px;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-around;

        > .filtered-content {
          display: flex;

          > .filtered-title {
            min-width: 185px;
            max-width: 185px;
          }

          > .filtered-colon {
            padding-left: 5px;
            padding-right: 5px;
          }
        }
      }

      > .right-side {
        padding-right: 5px;
      }
    }

    > .report-container {
      width: 100%;
      margin-bottom: 5px;
      padding: 5px;
      border-radius: 5px;
      background-color: white;
      display: flex;
    }

    > .custom-map-container {
      width: 100%;
      background-color: white;
      border-radius: 5px;
      padding: 0 5px 13px 5px;

      > .close-button-container {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        > .close-button {
          height: 25px;
          width: 25px;
          cursor: pointer;
        }
      }

      > .custom-map-component {
        height: calc(100% - 25px); // 100% minus height of close-button
      }
    }
  }

  //attachment popup
  .attchWin-main {
    width: calc(100%);
    height: calc(100% - 10px);
    padding: 5px;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    align-items: center;
    background-color: #00000048;
    z-index: 255;

    > .attchWin-close {
      height: 30px;
      width: 30px;
      font-weight: bold;
      border-radius: 50%;
      background-color: white;
      color: black;
      text-align: center;
      cursor: pointer;
      position: absolute;
      right: 0;
      top: 0;
      margin: 20px;
      font-size: 14px;
    }

    > .attchWin-display {
      width: 80%;
      margin: 0 auto;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      background-color: #eaeaea;
      border-radius: 3px;
      display: flex;
      height: 90vh;

      > .image-container {
        position: relative;
        float: left;
        width: 100%;
        height: 100%;
        border: 1px solid black;
        background: black;
        height: 100%;
        text-align: center;
        display: flex;

        > .leftButton {
          width: auto;
          height: 100%;
          float: left;
          align-items: center;
          left: 0;

          > .navButton-left {
            margin: 0 auot;
            position: relative;
            z-index: 300;
            font-size: 36px;
            color: white;
            background: none;
            top: 50%;

            &:hover {
              cursor: pointer;
              background: rgba(200, 200, 200, 0.8);
            }
          }
        }

        > .rightButton {
          width: auto;
          height: 100%;
          float: right;
          align-items: center;

          > .navButton-right {
            margin: 0;
            position: relative;
            top: 50%;
            float: right;
            /* -webkit-transform: translateY(-50%);
        transform: translateY(-50%); */
            z-index: 300;
            font-size: 36px;
            color: white;
            background: none;

            &:hover {
              cursor: pointer;
              background: rgba(200, 200, 200, 0.8);
            }
          }
        }

        > .attchWin-attachment {
          position: relative;
          margin: 0 auto;
          width: 80%;
          text-align: center;
          -o-object-fit: contain;
          object-fit: contain;
          float: left;
          align-self: center;
          //top: 25%;

          img {
            width: 70%;
            object-fit: contain;
            margin: 0 auto;
            max-height: 90vh;
          }

          &:hover {
            cursor: pointer;
          }

          iframe {
            width: 100%;
            height: 100%;
            min-height: 600px;
          }
        }
      }

      > .attchWin-details {
        //position: relative;
        float: left;
        width: 500px;
        height: 95%;
        min-width: 250px;
        // border: 1px solid black;
        display: grid;
        overflow: auto;

        > .attchWin-info {
          position: relative;
          margin: auto 5px 0;
          text-align: left;
          margin: 5px;
          height: fit-content;
          overflow-x: auto;

          #infoHeader {
            width: 100%;
            table-layout: fixed;
            font-size: 12px;
            border-collapse: collapse;
            background: #d4dfeb;
            margin: 5px 0px;
            border: 1px solid black;

            td {
              padding: 3px;
            }
            th {
              font-weight: bold;
              width: 92px;
            }
          }

          #tableContent {
            width: 100%;
            position: relative;
            table-layout: fixed;
            font-size: 12px;
            border-collapse: collapse;
            margin: 20px auto;
            background: #fff;
            align-self: center;
            text-align: left;

            tr {
              border: 1px solid black;
              padding: 3px;
            }
            td {
              padding: 3px;
              border: 1px solid black;
              overflow-x: auto;
            }
            th {
              font-weight: bold;
              background: #d4dfeb;
              border: 1px solid black;
              padding: 3px;
              width: 97px;
            }
          }
        }
        > .count {
          position: relative;
          width: auto;
          text-align: center;
          margin: auto 3px 0;
          margin-top: 5px;
          height: fit-content;
          border: 1px solid black;
          background: #a1a9b2;
        }
      }
    }
  }
}

@media only screen and (max-width: 900px) {
  .Haulage-Trip-Report-Main {
    flex-direction: column;

    > .left-container {
      height: 100%;
      max-height: 210px;
      max-width: unset;
      width: 100%;
      display: flex;
      flex-direction: row-reverse;
      justify-content: flex-start;
      margin-bottom: 5px;

      > .arrow-button {
        width: 30px;
        padding: 0;

        > img {
          margin-top: 2.5px;
          transform: rotate(90deg);
        }
      }

      > .refresh-icon {
        padding-bottom: 5px;
        padding-right: 5px;
      }

      > .left-container-content {
        width: 100%;
        align-items: center;

        > button {
          width: fit-content;
        }

        > .dropdown {
          width: 40%;
        }
      }
    }

    > .left-tab-close {
      max-height: 35px;
    }

    > .right-container > .generated-report-details &.left-side {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    > .right-container > .generated-report-details &.left-side {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
}
</style>
